export const scaleWithinArtBoard = (self, { el, scale: _scale }) => {
  const art_board_layer_el = self._getArtBoardLayerElThrowable();
  const art_board = self._getArtBoardThrowable();
  const scale_transform = self._getScaleTransformThrowable();
  const _ctm = art_board_layer_el.getCTM();
  if (_ctm == null) {
    throw new Error(`art_board_layer 엘리먼트의 CTM 을 찾을 수 없습니다.`);
  }
  const ctm = _ctm;
  const scale = _scale ?? 1;
  const width = art_board.getWidth() * scale;
  const height = art_board.getHeight() * scale;
  let origin_point = self._svg_el.createSVGPoint();
  origin_point.x = 0;
  origin_point.y = 0;
  origin_point = origin_point.matrixTransform(ctm);
  let width_point = self._svg_el.createSVGPoint();
  width_point.x = width;
  width_point.y = 0;
  width_point = width_point.matrixTransform(ctm);
  let height_point = self._svg_el.createSVGPoint();
  height_point.x = 0;
  height_point.y = height;
  height_point = height_point.matrixTransform(ctm);
  const width_in_view_port = Math.sqrt(
    (origin_point.x - width_point.x) ** 2 +
      (origin_point.y - width_point.y) ** 2
  );
  const height_in_view_port = Math.sqrt(
    (origin_point.x - height_point.x) ** 2 +
      (origin_point.y - height_point.y) ** 2
  );
  scale_transform.scaleSingleElFitTo({
    el,
    view_port_target_size: {
      width: width_in_view_port,
      height: height_in_view_port,
    },
  });
};
